import { Box, Card, Text } from "@aksara-ui/react";
import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";

import GoldMedal from "assets/images/icons/gold-medal.png";
import SilverMedal from "assets/images/icons/silver-medal.png";
import BronzeMedal from "assets/images/icons/bronze-medal.png";
import Illustration from "assets/images/illustration.png";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  ArcElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Pie, Bar } from "react-chartjs-2";
import styled from "styled-components";
import { InputSelect } from "components/Input";

const HeaderWrapper = styled(Box)`
  justify-content: space-between;
  margin-bottom: 30px;
  gap: 20px;
`;

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const GiftSummaryContent: React.FC = () => {
  const isMobile = useMediaQuery({ maxWidth: 576 });

  const [Type, setType] = useState("month");

  const participantGendersOptions = {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      legend: {
        position: "right" as const,
      },
      title: {
        display: true,
      },
    },
  };

  const participantGendersData = {
    labels: ["Female", "No Mention", "Male"],
    datasets: [
      {
        label: "Gender",
        data: [35, 15, 50],
        backgroundColor: [
          "rgba(253, 121, 168, 0.6)",
          "rgba(220, 221, 225, 1)",
          "rgba(74, 105, 189, 0.6)",
        ],
      },
    ],
  };

  const participantGrowthOptions = {
    indexAxis: "y" as const,
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      legend: {
        position: "bottom" as const,
      },
      title: {
        display: true,
      },
    },
  };

  const participantGrowthData = {
    labels: [
      "8/7/23",
      "8/6/23",
      "8/5/23",
      "8/4/23",
      "8/3/23",
      "8/2/23",
      "8/1/23",
    ],
    datasets: [
      {
        label: "Participant",
        data: [600, 700, 400, 500, 300, 200, 100],
        backgroundColor: ["rgba(74, 105, 189, 0.4)"],
      },
    ],
  };

  const ageOptions = {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      legend: {
        position: "bottom" as const,
      },
      title: {
        display: true,
      },
    },
  };

  const ageData = {
    labels: ["18-24", "25-34", "35-44", "45-54", "55-64", "65+"],
    datasets: [
      {
        label: "Age",
        data: [320, 650, 690, 500, 350, 100],
        backgroundColor: ["rgba(119, 139, 235, 0.7)"],
      },
    ],
  };

  const locationOptions = {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      legend: {
        position: "bottom" as const,
      },
      title: {
        display: true,
      },
    },
  };

  const locationData = {
    labels: ["Jakarta", "Bogor", "Depok", "Tangerang", "Bekasi", "Bandung"],
    datasets: [
      {
        label: "Location",
        data: [630, 400, 450, 550, 550, 590],
        backgroundColor: ["rgba(99, 205, 218, 0.8)"],
      },
    ],
  };

  return (
    <Box height={"100%"} paddingY={20} paddingX={isMobile ? 30 : 50}>
      <HeaderWrapper display={"flex"} flexDirection={"column"}>
        <Box display={"flex"}>
          <Text scale={[500, 600]} fontWeight={700}>
            Gift Summary
          </Text>
        </Box>

        <Box display={"flex"} alignItems={"center"}>
          <Text color="grey07" fontWeight={700} marginRight={10}>
            View By
          </Text>
          <InputSelect
            items={[
              {
                label: "Month",
                value: "month",
              },
              {
                label: "Day",
                value: "day",
              },
              {
                label: "Year",
                value: "year",
              },
            ]}
            label=""
            value={Type}
            handleChange={(e: any) => {
              setType(e);
            }}
            boxStyle={{ width: "15%", borderRadius: 20 }}
          />
        </Box>
      </HeaderWrapper>

      <Box
        display={"flex"}
        justifyContent={"space-between"}
        flexDirection={isMobile ? "column" : "row"}
        marginY={50}
        style={{ gap: 30 }}
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          width={isMobile ? "100%" : "50%"}
          style={{ gap: 10 }}
        >
          <Text
            color="grey07"
            scale={400}
            fontWeight={"bold"}
            marginBottom={10}
          >
            MAIN GIFT
          </Text>
          <Card
            elevation={2}
            paddingX={40}
            paddingY={30}
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"space-evenly"}
          >
            <Box
              display={"flex"}
              alignItems={"top"}
              width={"50%"}
              flexDirection={"column"}
              style={{ gap: 10 }}
            >
              <Text scale={400} fontWeight={"bold"}>
                Rewards
              </Text>
              <img
                src={Illustration}
                width={"100%"}
                alt="illustration"
                style={{ borderRadius: 10 }}
              />
            </Box>
            <Box
              display={"flex"}
              width={"50%"}
              alignItems={"center"}
              justifyContent={"center"}
              flexDirection={"column"}
              style={{ gap: 10 }}
            >
              <Text color={"blue06"} scale={[600, 700]} fontWeight={"bold"}>
                3 tickets
              </Text>
              <Text color={"gray"} scale={200} fontWeight={400}>
                worth USD 12,217
              </Text>
            </Box>
          </Card>
        </Box>

        <Box
          display={"flex"}
          flexDirection={"column"}
          width={isMobile ? "100%" : "50%"}
          style={{ gap: 10 }}
        >
          <Text color="grey07" scale={400} fontWeight={"bold"}>
            WINNER LEADERBOARD
          </Text>
          <Text
            color="grey07"
            scale={400}
            fontWeight={"bold"}
            marginBottom={10}
          >
            Channel: #giveaway
          </Text>

          <Card
            p={"md"}
            style={{ border: "1px solid #C6D0DB", borderRadius: 30, gap: 10 }}
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
          >
            <img src={GoldMedal} width={"40px"} alt="gold-medal" />
            <Text scale={300} fontWeight={500}>
              sapiyjagoan87
            </Text>
          </Card>

          <Card
            p={"md"}
            style={{ border: "1px solid #C6D0DB", borderRadius: 30, gap: 10 }}
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
          >
            <img src={SilverMedal} width={"40px"} alt="silver-medal" />
            <Text scale={300} fontWeight={500}>
              CIGANTENK
            </Text>
          </Card>

          <Card
            p={"md"}
            style={{ border: "1px solid #C6D0DB", borderRadius: 30, gap: 10 }}
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
          >
            <img src={BronzeMedal} width={"40px"} alt="bronze-medal" />
            <Text scale={300} fontWeight={500}>
              lololololalalayeye
            </Text>
          </Card>
        </Box>
      </Box>

      <Box
        display={"flex"}
        justifyContent={"space-between"}
        flexDirection={isMobile ? "column" : "row"}
        marginBottom={50}
        style={{ gap: 30 }}
      >
        <Box width={isMobile ? "100%" : "50%"} height={400}>
          <Text color="grey07" scale={400} fontWeight={"bold"}>
            PARTICIPANT GROWTH
          </Text>

          <Bar
            options={participantGrowthOptions}
            data={participantGrowthData}
          />
        </Box>

        <Box width={isMobile ? "100%" : "50%"} height={350}>
          <Text color="grey07" scale={400} fontWeight={"bold"}>
            PARTICIPANT GENDER
          </Text>

          <Pie
            options={participantGendersOptions}
            data={participantGendersData}
          />
        </Box>
      </Box>

      <Box
        display={"flex"}
        justifyContent={"space-between"}
        flexDirection={isMobile ? "column" : "row"}
        marginBottom={50}
        style={{ gap: 30 }}
      >
        <Box width={isMobile ? "100%" : "35%"} height={400}>
          <Text color="grey07" scale={400} fontWeight={"bold"}>
            AGE
          </Text>

          <Bar options={ageOptions} data={ageData} />
        </Box>

        <Box width={isMobile ? "100%" : "60%"} height={400}>
          <Text color="grey07" scale={400} fontWeight={"bold"}>
            LOCATION
          </Text>

          <Bar options={locationOptions} data={locationData} />
        </Box>
      </Box>
    </Box>
  );
};

export default GiftSummaryContent;
